/**
 * Full Admin Theme Configuration
 *
 * Theme for the full admin portal (/admin/)
 * Monochromatic palette with #1a1a2e as primary; indigo accent for actions and highlights.
 */

import { AdminThemeConfig } from '@app-types/admin-theme';

export const fullAdminTheme: AdminThemeConfig = {
  adminType: 'full',
  siteType: undefined,
  siteName: 'レセプロ 管理ポータル',

  adminTheme: {
    name: 'Admin',
    displayName: 'レセプロ Admin',
    colors: {
      primary: '#334155',           // Slate-700 – main (lighter than #1a1a2e)
      primaryHover: '#475569',     // Slate-600
      primaryDark: '#1e293b',      // Slate-800 – footer
      secondary: '#6366f1',        // Indigo – buttons, links
      sidebarBg: '#334155',        // Same as primary
      sidebarText: '#f1f5f9',      // Slate-100
      menuOpen: 'rgba(0, 0, 0, 0.12)',
      menuHover: 'rgba(255, 255, 255, 0.1)',
      menuActive: 'rgba(99, 102, 241, 0.35)', // Indigo tint – active item
      sectionHeader: '#475569',     // Slate-600 – cards/sections
      sectionHeaderText: '#f1f5f9',
    },
    logoPath: '/images/admin/logo_admin.png',
    sidebarWidth: 'w-60',
  },
};
